'use client';

import { useState, useEffect } from 'react';
import Link from "next/link";
import { useCookieConsent } from "@/context/CookieConsentContext";

const siteConfig = {
  name: "kzoek.com",
};

export default function GlobalFooter() {
  const { openSettings } = useCookieConsent();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Prevent hydration mismatch by using a fixed year on server and first client render
  const currentYear = mounted ? new Date().getFullYear() : 2025;

  return (
    <footer className="bg-muted py-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8 text-muted-foreground">
        <div>
          <h3 className="font-bold text-lg text-foreground">{siteConfig.name}</h3>
          <p className="mt-2 text-sm">Vind snel en eenvoudig lokale diensten in uw buurt.</p>
        </div>
        <div>
          <h3 className="font-bold text-lg text-foreground">Sitemap</h3>
          <ul className="mt-2 space-y-2 text-sm">
            <li><Link href="/" className="hover:text-foreground">Home</Link></li>
            {mounted ? (
              <>
                <li><Link href="/blog" className="hover:text-foreground">Blog</Link></li>
                <li><Link href="/over-ons" className="hover:text-foreground">Over Ons</Link></li>
                <li><Link href="/contact" className="hover:text-foreground">Contact</Link></li>
              </>
            ) : (
              <>
                <li className="h-5 w-16 bg-muted animate-pulse rounded" />
                <li className="h-5 w-20 bg-muted animate-pulse rounded" />
                <li className="h-5 w-16 bg-muted animate-pulse rounded" />
              </>
            )}
          </ul>
        </div>
        <div>
          <h3 className="font-bold text-lg text-foreground">Wettelijk</h3>
          <ul className="mt-2 space-y-2 text-sm">
            <li><Link href="/privacy" className="hover:text-foreground">Privacy & Disclaimer</Link></li>
            <li>
              <button 
                onClick={openSettings} 
                className="bg-transparent border-none p-0 text-left text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Cookie-instellingen
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-8 border-t border-muted-foreground/20 pt-4 text-center text-sm text-muted-foreground">
        <p>&copy; {currentYear} {siteConfig.name}. Alle rechten voorbehouden.</p>
      </div>
    </footer>
  );
}
